import apiClient from "../../service/apiClient";
import qs from "qs";
import { GetDistributorsResponse } from "../models/response/get-distributors-response";
import { GetDistributorRequest } from "../models/request/get-distributor-request";
import { GetDistributorResponse } from "../models/response/get-distributor-response";
import { EditDistributorRequest } from "../models/request/edit-distributor-request";
import { EditDistributorResponse } from "../models/response/edit-distributor-response";
import { DeleteDistributorRequest } from "../models/request/delete-distributor-request";
import { DeleteDistributorResponse } from "../models/response/delete-distributor-response";
import { CreateDistributorRequest } from "../models/request/create-distributor-request";
import { CreateDistributorResponse } from "../models/response/create-distributor-response";
import { GetFiltersRequest } from "pages/admin-app/shared/models/request/get-filters-request";
import { GetFiltersResponse } from "pages/admin-app/shared/models/response/get-filters-response";
import { GetDistributorsRequest } from "../models/request/get-distributors-request";

export async function getPaginatedDistributors(
  request: GetDistributorsRequest
): Promise<GetDistributorsResponse> {
  const response = await apiClient.get<GetDistributorsResponse>(
    "/distributor",
    {
      params: {
        page: request.page,
        perPage: request.perPage,
      },
    }
  );
  return response.data;
}

export async function getPaginatedByNameDistributors(
  request: GetDistributorsRequest
): Promise<GetDistributorsResponse> {
  const response = await apiClient.get<GetDistributorsResponse>(
    "/distributor/search-by-name",
    {
      params: {
        page: request.page,
        perPage: request.perPage,
        searchQuery: request.searchQuery,
      },
    }
  );
  return response.data;
}

export async function getDistributors(
  request: GetDistributorsRequest
): Promise<GetDistributorsResponse> {
  const response = await apiClient.get<GetDistributorsResponse>(
    "/distributor/search",
    {
      params: {
        page: request.page,
        perPage: request.perPage,
        sortBy: request.sortBy,
        orderBy: request.orderBy,
        filters: request.filters,
        searchQuery: request.searchQuery,
      },
      paramsSerializer: (params) =>
        qs.stringify(params, { encode: true, arrayFormat: "brackets" }),
    }
  );
  return response.data;
}

export async function getDistributor(
  request: GetDistributorRequest
): Promise<GetDistributorResponse> {
  const response = await apiClient.get<GetDistributorResponse>(
    `/distributor/${request.distributorId}`
  );
  return response.data;
}

export async function updateDistributor({
  distributorId,
  ...distributorData
}: EditDistributorRequest): Promise<EditDistributorResponse> {
  const response = await apiClient.patch<EditDistributorResponse>(
    `/distributor/${distributorId}`,
    distributorData
  );
  return response.data;
}

export async function deleteDistributor(
  request: DeleteDistributorRequest
): Promise<DeleteDistributorResponse> {
  const response = await apiClient.delete<DeleteDistributorResponse>(
    `/distributor/${request.distributorId}`
  );

  return response.data;
}

export async function createDistributor(
  distributorData: CreateDistributorRequest
): Promise<CreateDistributorResponse> {
  const response = await apiClient.post<CreateDistributorResponse>(
    "/distributor",
    distributorData
  );
  return response.data;
}

export async function getDistributorFilters(
  request: GetFiltersRequest
): Promise<GetFiltersResponse> {
  const response = await apiClient.get<GetFiltersResponse>(
    "/distributor/filters",
    {
      params: {
        field: request.field,
        subCategoryQuery: request.subCategoryQuery,
        limit: request.limit,
        afterKey: request.afterKey,
      },
    }
  );
  return response.data;
}
